import { render } from "./DashboardBrandManagementMobile.vue?vue&type=template&id=4df5886c&scoped=true&ts=true"
import script from "./DashboardBrandManagementMobile.vue?vue&type=script&lang=ts"
export * from "./DashboardBrandManagementMobile.vue?vue&type=script&lang=ts"

import "./DashboardBrandManagementMobile.vue?vue&type=style&index=0&id=4df5886c&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df5886c"]])

export default __exports__